const EMPLOYEES = () => `/users`
const EMPLOYEES_BY_ID = (id: string) => `${EMPLOYEES()}/${id}`
const EMPLOYEES_ROLE = () => `${EMPLOYEES()}/roles`

export default {
  EMPLOYEES,
  EMPLOYEES_BY_ID,
  EMPLOYEES_ROLE,
}
